{
  "LoadingLabel": "[Caricamento...]",
  "NAME": "ComboBox"
}